"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MorBusinessInformation = void 0;
const BusinessKrn_1 = require("./morbusinessinformation/BusinessKrn");
const CompanyName_1 = require("./morbusinessinformation/CompanyName");
const GroupOnboardingKrn_1 = require("./morbusinessinformation/GroupOnboardingKrn");
const HasNomineeShareholders_1 = require("./morbusinessinformation/HasNomineeShareholders");
const IssueBearerShares_1 = require("./morbusinessinformation/IssueBearerShares");
const LegalForm_1 = require("./morbusinessinformation/LegalForm");
const Persons_1 = require("./morbusinessinformation/Persons");
const RegisteredAddress_1 = require("./morbusinessinformation/RegisteredAddress");
const RegistrationAuthority_1 = require("./morbusinessinformation/RegistrationAuthority");
const RegistrationId_1 = require("./morbusinessinformation/RegistrationId");
const VatId_1 = require("./morbusinessinformation/VatId");
exports.MorBusinessInformation = {
    business_krn: BusinessKrn_1.BusinessKrn,
    company_name: CompanyName_1.CompanyName,
    group_onboarding_krn: GroupOnboardingKrn_1.GroupOnboardingKrn,
    has_nominee_shareholders: HasNomineeShareholders_1.HasNomineeShareholders,
    issue_bearer_shares: IssueBearerShares_1.IssueBearerShares,
    legal_form: LegalForm_1.LegalForm,
    persons: Persons_1.Persons,
    registered_address: RegisteredAddress_1.RegisteredAddress,
    registration_authority: RegistrationAuthority_1.RegistrationAuthority,
    registration_id: RegistrationId_1.RegistrationId,
    vat_id: VatId_1.VatId,
};
